<template>
  <div class="pay-record-wrapper">
    <van-empty v-if="this.list.length == 0" description="暂无记录" />
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="this.list.length != 0 ? '没有更多了' : ''"
      @load="onLoad"
    >
      <van-cell class="item-wrapper" v-for="(item, index) in list" :key="index">
        <div class="cell-wrapper">
          <span class="cell-title">充值成功</span>
          <div class="cell-item van-hairline--bottom">
            <p class="cell-item-up">家长:</p>
            <p class="cell-item-down">{{parentName}} (ID: {{parentId}})</p>
          </div>
          <div class="cell-item van-hairline--bottom">
            <p class="cell-item-up">充值订单:</p>
            <p class="cell-item-down">{{item.title}}</p>
          </div>
          <div class="cell-item">
            <p class="cell-item-up">到账时间</p>
            <p class="cell-item-down">{{createTime(item.createTime)}}</p>
          </div>
        </div>
      </van-cell>
    </van-list>
  </div>
</template>

<script>
  import {postParentPaid, groupBuyOrderpaid} from "@/api/groupbuy";
  import Vue from "vue";
  import {dateFormat} from "@/lib/util";

  export default {
    data() {
      return {
        list: [],
        loading: false,
        finished: false,
        page: 0,
        parentName: '',
        parentId: '',
      }
    },

    created() {

    },

    activated() {
      this.requset_groupBuyOrderpaid()
      this.parentName = this.$route.query.nickname;
      this.parentId = this.$route.query.parentId;
    },

    methods: {
      createTime(time) {
        return dateFormat(time, 'YYYY-MM-DD hh:mm')
      },

      onLoad() {
        //加载列表数据
        setTimeout(() => {
          this.requset_groupBuyOrderpaid()
        }, 500)
      },

      //加载订单数据
      requset_groupBuyOrderpaid() {
        let _THAT = this;
        const parentId = this.$route.query.parentId;
        let params = {pageIndex: _THAT.page, pageSize: 30, parentId};
        postParentPaid(params).then(res => {
            _THAT.loading = false;
            if (res.code === 0) {
              if (_THAT.page == 1){
                _THAT.list = [];
              }

              if (res.data.records && res.data.records.length > 0) {
                _THAT.list.push(...res.data.records)
              }
              if ((res.data.records && res.data.records.length < 30) || (!res.data.records)) {
                _THAT.finished = true;
              }
              _THAT.page++;
            } else {
              _THAT.finished = true;
            }
          }
        ).catch((err) => {
          this.$toast(JSON.stringify(err))
          _THAT.loading = false;
          _THAT.finished = true;
        })
      },

      //================================================
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import "../stylesheet/common.styl"
  .pay-record-wrapper {
    box-sizing: border-box;
    min-height: 100vh;
    padding: 8px 20px;
    background-color: #F3F5F9;
    font-size: 14PX;
    color: #333;
    overflow: hidden;
  }

  .item-wrapper {
    background-color: #fff;
    margin-top: 8px;
    border-radius: 6px;
    padding: 10px 10px;
    font-size: 14PX;
    color: #999;
  }

  .cell-title{
    background-color: $common-blue;
    padding: 6px 20px;
    line-height: 34px;
    height: 34px;
    color: #fff;
    font-size: 15px;
    border-radius: 10px;
  }

  .cell-item{
    padding: 10px 10px;
    .cell-item-up{
      color: $common-blue;
    }
  }
</style>



// WEBPACK FOOTER //
// app/pages/family/ParentPayReocord.vue